// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"2066":"258808da","4152":"1198b8e1","4312":"258808da","5601":"0abe3a12","7627":"d99365a3","9448":"258808da","9631":"0abe3a12"}[chunkId] + ".chunk.css";
};